import type { SVGProps } from "react";
// generated from Close.svg — do not edit manually
// prettier-ignore
export default function Close(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 17 7 L 7 17 M 7 7 L 17 17" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
